import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const UserActivitiesPage = ({ panelId }) => {
    const [logs, setLogs] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [uniqueActions, setUniqueActions] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [filters, setFilters] = useState({
        user: '',
        action: '',
        startDate: '',
        endDate: ''
    });

    const fetchUsers = useCallback(async () => {
        try {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || currentUser?.panelId;
            const res = await api.getUsers({ panelId: activePanelId || '' });
            setUsersList(res.data);
        } catch (error) {
            console.error('Kullanıcılar alınamadı:', error);
        }
    }, [panelId]);

    const fetchLogs = useCallback(async () => {
        try {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || currentUser?.panelId;
            const res = await api.getLogs({ panelId: activePanelId || '' });
            setLogs(res.data);
            const actions = [...new Set(res.data.map(log => log.action))].filter(Boolean);
            setUniqueActions(actions);
        } catch (error) {
            console.error('Loglar alınamadı:', error);
        }
    }, [panelId]);

    useEffect(() => {
        document.title = 'PayzoPay - Kullanıcı Hareketleri';
        fetchLogs();
        fetchUsers();
        const interval = setInterval(() => {
            fetchLogs();
        }, 5000);
        return () => clearInterval(interval);
    }, [fetchLogs, fetchUsers]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const filteredLogs = logs.filter(log => {
        const logDate = new Date(log.timestamp);
        const start = filters.startDate ? new Date(filters.startDate) : null;
        const end = filters.endDate ? new Date(filters.endDate) : null;

        if (start) start.setHours(0, 0, 0, 0);
        if (end) end.setHours(23, 59, 59, 999);

        const matchesUser = filters.user ? (log.username || '').toLowerCase().includes(filters.user.toLowerCase()) : true;
        const matchesAction = filters.action ? (log.action || '').toLowerCase().includes(filters.action.toLowerCase()) : true;
        const matchesDate = (!start || logDate >= start) && (!end || logDate <= end);

        return matchesUser && matchesAction && matchesDate;
    });

    const labelStyle = { fontWeight: 'bold', fontSize: '0.9em', marginBottom: '5px', display: 'block', color: 'var(--text-color)' };
    const inputStyle = { width: '100%', padding: '8px', border: '1px solid var(--input-border)', borderRadius: '4px', boxSizing: 'border-box', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)' };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ color: '#fff', margin: 0 }}>Kullanıcı Hareketleri</h2>
                <button
                    onClick={() => setShowFilters(!showFilters)}
                    style={{
                        padding: '8px 16px',
                        borderRadius: '20px',
                        border: 'none',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                    }}
                >
                    {showFilters ? 'Filtreleri Gizle' : 'Filtreleri Göster'}
                </button>
            </div>

            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '15px', boxShadow: 'var(--shadow)', overflow: 'hidden' }}>
                {showFilters && (
                    <div style={{ padding: '20px', borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--table-header-bg)', transition: 'all 0.3s ease' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
                            <div>
                                <label style={labelStyle}>Kullanıcı</label>
                                <select name="user" value={filters.user} onChange={handleFilterChange} style={inputStyle}>
                                    <option value="">Hepsi</option>
                                    {usersList.map(u => (
                                        <option key={u._id} value={u.username}>{u.username}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label style={labelStyle}>İşlem</label>
                                <select name="action" value={filters.action} onChange={handleFilterChange} style={inputStyle}>
                                    <option value="">Hepsi</option>
                                    {uniqueActions.map((act, index) => (
                                        <option key={index} value={act}>{act}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label style={labelStyle}>Başlangıç Tarihi</label>
                                <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} style={inputStyle} />
                            </div>
                            <div>
                                <label style={labelStyle}>Bitiş Tarihi</label>
                                <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} style={inputStyle} />
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ padding: '20px' }}>
                    <table cellPadding="15" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px', color: 'var(--text-color)' }}>
                        <thead>
                            <tr style={{ backgroundColor: 'var(--table-header-bg)', borderBottom: '2px solid var(--border-color)', textAlign: 'left' }}>
                                <th>Kullanıcı</th>
                                <th>İşlem</th>
                                <th>Detay</th>
                                <th>Tarih</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLogs.map(log => {
                                const rowBg = 'var(--table-row-even)';
                                const radius = '15px';
                                return (
                                    <tr key={log._id}>
                                        <td style={{ backgroundColor: rowBg, borderTopLeftRadius: radius, borderBottomLeftRadius: radius, fontWeight: 'bold' }}>{log.username}</td>
                                        <td style={{ backgroundColor: rowBg }}>{log.action}</td>
                                        <td style={{ backgroundColor: rowBg }}>{log.details}</td>
                                        <td style={{ backgroundColor: rowBg, borderTopRightRadius: radius, borderBottomRightRadius: radius }}>{new Date(log.timestamp).toLocaleString()}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserActivitiesPage;